module.exports = __webpack_public_path__ + "img/hammock-blanket.00db356b.jpeg";